







































































































































































































































































import Vue from 'vue';
import draggable from 'vuedraggable';
import SaveData from '@/classes/saveData/saveData';
import SiteSetting from '@/classes/siteSetting';
import Const from '@/classes/const';
import max from 'lodash/max';

export default Vue.extend({
  name: 'SaveDataTab',
  components: { draggable },
  props: {
    saveData: {
      type: SaveData,
      required: true,
    },
  },
  data: () => ({
    deleteConfirmDialog: false,
    editDialog: false,
    editedName: '',
    editedRemarks: '',
    editedIsUnsaved: false,
    editedIsDirectory: false,
    selectedColor: '',
    lastModified: '',
    editedFile: undefined as SaveData | undefined,
    deleteConfirmData: undefined as SaveData | undefined,
    disabledConfirm: false,
    fileColors: Const.FILE_COLORS,
    reload: false,
    showExternals: false,
    externalsX: 0,
    externalsY: 0,
    externalWorlds: [] as string[],
    closeExternalConfirmDialog: false,
  }),
  computed: {
    viewData(): SaveData[] {
      if (this.reload) {
        return [];
      }
      let activeData: SaveData[] = [];
      const data = this.saveData.childItems;
      for (let i = 0; i < data.length; i += 1) {
        const actives = data[i].fetchActiveData().filter((v) => !v.isUnsaved || v.name !== '外部データ');
        if (actives) {
          activeData = activeData.concat(actives);
        }
      }
      activeData.sort((a, b) => a.activeOrder - b.activeOrder);
      return activeData;
    },
    externalData(): SaveData[] {
      if (this.reload) {
        return [];
      }
      let activeData: SaveData[] = [];
      const data = this.saveData.childItems;
      for (let i = 0; i < data.length; i += 1) {
        const actives = data[i].fetchActiveData().filter((v) => v.isUnsaved && v.name === '外部データ');
        if (actives) {
          activeData = activeData.concat(actives);
        }
      }
      activeData.sort((a, b) => a.activeOrder - b.activeOrder);
      return activeData;
    },
    isExternalMain(): boolean {
      return this.externalData.some((v) => v.isMain);
    },
    isNameEmpty(): boolean {
      return this.editedName.length <= 0;
    },
    mainData(): SaveData | undefined {
      return this.saveData.getMainData();
    },
  },
  watch: {
    editDialog(value) {
      if (value) {
        setTimeout(() => {
          (this.$refs.nameInput as HTMLInputElement).focus();
        }, 150);
      }
    },
  },
  methods: {
    textFieldFocused(focusEvent: FocusEvent) {
      if (focusEvent) (focusEvent.target as HTMLInputElement).select();
    },
    sortEnd() {
      const base = document.getElementById('active-tab-list') as HTMLElement;
      const itemElements = base.getElementsByClassName('tab-item');

      for (let i = 0; i < this.viewData.length; i += 1) {
        const data = this.viewData[i];
        const targetElement = document.getElementById(data.id);
        if (targetElement) {
          const index = ([].slice.call(itemElements) as HTMLElement[]).indexOf(targetElement);
          data.activeOrder = index ?? 0;
        }
      }

      // インデックスが変更になったので
      this.$store.dispatch('updateSaveData', this.saveData);
      this.reload = true;
      this.$nextTick(() => {
        this.reload = false;
      });
    },
    showNameEditDialog(data: SaveData) {
      this.editedFile = data;
      this.editedName = data.name;
      if (data.isUnsaved && data.name === '外部データ') {
        this.editedName = '';
      }
      this.editedRemarks = data.remarks;
      this.editedIsUnsaved = data.isUnsaved;
      this.editedIsDirectory = data.isDirectory;
      this.selectedColor = data.color;
      this.lastModified = new Date(data.editedDate).toLocaleString(this.$vuetify.lang.current);
      this.editDialog = true;
    },
    handleCloseExternalAll(event: MouseEvent) {
      event.stopPropagation();
      event.preventDefault();

      // 外部データがメイン計算画面かどうか取得
      const isMain = this.externalData.some((v) => v.isMain);

      // 外部データのみ消し飛ばす
      this.saveData.childItems = this.saveData.childItems.filter((v) => v.name !== '外部データ' || !v.isUnsaved);

      if (isMain) {
        const actives = this.saveData.fetchActiveData();
        if (actives.length) {
          const nextData = actives[actives.length - 1];
          nextData.isMain = true;
          this.$store.dispatch('setMainSaveData', nextData);
        }
      }

      // 閉じたということでDB更新を促す
      this.$store.dispatch('updateSaveData', this.saveData);
      this.closeExternalConfirmDialog = false;

      // もう何もタブがなかったらトップページに戻す
      if (!this.saveData.getMainData() && this.$route.path === '/aircalc') {
        this.$router.push('/');
      }
    },
    handleCloseTab(data: SaveData, event: MouseEvent) {
      event.stopPropagation();
      event.preventDefault();

      const setting = this.$store.state.siteSetting as SiteSetting;
      if (setting.confirmCloseTab && (data.isEdited || data.isUnsaved)) {
        this.deleteConfirmDialog = true;
        this.deleteConfirmData = data;
        return;
      }

      this.closeTab(data);
    },
    closeTab(data: SaveData | undefined) {
      if (!data) {
        return;
      }

      this.deleteConfirmDialog = false;
      this.deleteConfirmData = undefined;

      data.isActive = false;
      // 履歴を吹き飛ばす
      data.tempData = [];
      data.tempIndex = -1;

      if (data.isMain) {
        data.isMain = false;
        // メイン計算処理を他のデータに移譲
        const actives = this.saveData.fetchActiveData();
        if (actives.length) {
          const nextData = actives[actives.length - 1];
          nextData.isMain = true;
          this.$store.dispatch('setMainSaveData', nextData);
        }
      }

      // 非保存データなら消し飛ばす
      if (data.isUnsaved) {
        const index = this.saveData.childItems.findIndex((v) => v === data);
        if (index) {
          this.saveData.childItems = this.saveData.childItems.filter((v, i) => i !== index);
        }
      }

      // 設定書き換え
      const setting = this.$store.state.siteSetting as SiteSetting;
      if (this.disabledConfirm && setting.confirmCloseTab) {
        setting.confirmCloseTab = false;
        this.$store.dispatch('updateSetting', setting);
      }

      // 外部データ表示されているなら、海域情報の更新だけ
      if (this.showExternals) {
        this.setExternalWorlds();
      }

      // 閉じたということでDB更新を促す
      this.$store.dispatch('updateSaveData', this.saveData);

      // もう何もタブがなかったらトップページに戻す
      if (!this.saveData.getMainData() && this.$route.path === '/aircalc') {
        this.$router.push('/');
      }
    },
    commitName() {
      if (this.isNameEmpty) {
        return;
      }
      if (this.editedFile) {
        this.editedFile.name = this.editedName;
        this.editedFile.remarks = this.editedRemarks;
        this.editedFile.color = this.selectedColor;
        this.editedFile.editedDate = Date.now();
        this.editedFile = undefined;
      }
      this.editDialog = false;

      // DB更新を促す
      this.$store.dispatch('updateSaveData', this.saveData);
    },
    clickSaveData(data: SaveData) {
      if (!data.isMain) {
        // 他の全ての計算状態を解除
        this.saveData.disabledMain();
        // 自身を計算状態に変更
        data.isMain = true;
        this.$store.dispatch('setMainSaveData', data);
        if (!this.$route.path.endsWith('/aircalc')) {
          this.$router.push('aircalc');
        }
      } else {
        this.showNameEditDialog(data);
      }
    },
    showExternalMenu(e: MouseEvent) {
      if (e && e.target && e.target instanceof HTMLElement && e.target.closest('.tab-item')) {
        const rect = (e.target.closest('.tab-item') as HTMLElement).getBoundingClientRect();
        this.externalsX = rect.left;
        this.externalsY = rect.bottom;

        this.setExternalWorlds();
        this.showExternals = true;
      }
    },
    setExternalWorlds() {
      // 海域の情報だけぶっこ抜く処理
      this.externalWorlds = [];

      for (let i = 0; i < this.externalData.length; i += 1) {
        const data = this.externalData[i];
        const area = data.getLastBattleArea();
        const world = Math.floor(area / 10);

        let areaText = '';
        if (area) {
          areaText = `#${world > 40 ? 'E' : world}-${area % 10}`;
        }

        this.externalWorlds.push(areaText);
      }
    },
    addNewFile() {
      // 新規タブ追加
      const data = new SaveData();
      data.name = this.saveData.getNewSaveDataName();
      if (this.$i18n.locale !== 'ja') {
        data.name = data.name.replace('新規データ', `${this.$t('SaveData.新規データ')} `);
      }
      data.isActive = true;
      // 最大のソート番号を取得
      data.activeOrder = max(this.viewData.map((v) => v.activeOrder)) ?? 1;
      // 追加先はルート直下
      this.saveData.childItems.push(data);

      this.clickSaveData(data);
    },
    keydownHandler(event: KeyboardEvent) {
      if (event.ctrlKey && event.code === 'KeyS') {
        event.preventDefault();
        event.stopPropagation();
        this.commitName();
      }
    },
  },
});
